module.exports = __webpack_public_path__ + "img/needs_validation.46aa1004.svg";